// Foco e rolagem. O app roda com HashRouter, então link "#id" quebraria a rota: o resumo de erros usa botão
// e vem por aqui.
const reduced = () => typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

const FOCUSABLE = 'input:not([disabled]):not([type="hidden"]), button:not([disabled]), textarea:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'

const isFocusable = (el: HTMLElement) =>
  /^(INPUT|BUTTON|TEXTAREA|SELECT|A)$/.test(el.tagName) || el.hasAttribute('tabindex')

/** Leva o foco (e a tela) até o campo. Se o id é de um grupo, foca o primeiro controle dele. */
export function focusField(id: string, block: ScrollLogicalPosition = 'center') {
  const el = document.getElementById(id)
  if (!el) return
  el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block })
  // grupo de opções (radio): foca a escolhida, não a primeira
  const target = isFocusable(el) ? el : (el.querySelector<HTMLElement>('input:checked') ?? el.querySelector<HTMLElement>(FOCUSABLE))
  target?.focus({ preventScroll: true })
}

/** Sobe até o topo do cadastro e põe o foco no elemento indicado (título da etapa, resumo de erros...). */
export function focusTop(focusId: string, topId = 'topo') {
  window.setTimeout(() => {
    document.getElementById(topId)?.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' })
    document.getElementById(focusId)?.focus({ preventScroll: true })
  }, 40)
}
